export default {
  title: 'Patientez, vous allez être redirigé !',
  subtitle: 'Nous validons la signature du devis.',
};
